/* eslint-disable react-hooks/exhaustive-deps */
import {
    IonContent,
    IonPage,
    useIonViewDidEnter,
    useIonViewDidLeave,
} from '@ionic/react'
import cx from 'classnames'
import React, { useState, useEffect } from 'react'
import Header from '../../components/Header'
import {
    MyBotIcon,
    SearchIcon,
    IdiomIcon,
    ConfrontationIcon,
    LegalIcon,
    TourismIcon,
    AnswerIcon,
    ConstellationIcon,
    HrIcon,
} from '../../conf/images'
import './index.css'
import EmptyMsg from '../../components/EmptyMsg'
import { getStoreBots, installStoreBot } from '../../service/api/bot'
import { BotModel } from '../../model/bot.model'
import BotItem from '../../components/BotItem'
import { useHistory } from 'react-router'
import { MyBotPage, BotDetailPage } from '../../conf/routePath'
import SearchBar from '../../components/SearchBar'
import Toast from '../../components/Toast'

interface HeaderOptionsProps {
    onSearch?: () => void
    onGoMyBot?: () => void
}
const HeaderOptions: React.FC<HeaderOptionsProps> = (props) => {
    return (
        <div className='header-options'>
            <img
                className='bot-search-icon botstore-icon'
                onClick={props.onSearch}
                src={SearchIcon}
                alt='store'
            />
            <img
                className='mybot-store-icon botstore-icon'
                onClick={props.onGoMyBot}
                src={MyBotIcon}
                alt='store'
            />
        </div>
    )
}
let refreshTimer: any = null
const BotStore: React.FC = () => {
    const history = useHistory()
    const [searchBarShow, setSearchBarShow] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [botList, setBotList] = useState<BotModel[]>([])
    const [botType, setBotType] = useState<'KNOWLEDGE' | 'SKILL' | undefined>()
    const [policy, setPolicy] = useState<1 | 2>(2)
    const [toast, setToast] = useState({
        isOpen: false,
        message: '',
    })

    // const debounce = useDebounce(searchValue, 500)
    useIonViewDidEnter(() => {
        if (policy !== 2) {
            setPolicy(2)
            return
        }
        queryStoreBots()
    })
    useIonViewDidLeave(() => {
        clearTimeout(refreshTimer)
    })
    useEffect(() => {
        return () => {
            clearTimeout(refreshTimer)
        }
    }, [])
    useEffect(() => {
        if (policy === 1 && !searchValue) {
            return
        }
        queryStoreBots()
    }, [policy])
    useEffect(() => {
        queryStoreBots()
    }, [botType])
    useEffect(() => {
        if (searchValue) {
            queryStoreBots()
        }
    }, [searchValue])
    const queryStoreBots = async () => {
        try {
            let params: any = {
                policy: policy,
                bot_type: botType,
            }
            if (policy === 1) {
                params.gift_code = searchValue
            }
            let res = await getStoreBots(params)
            const is_exists_installing =
                res.data.filter((item) => item.status === 1).length > 0
            clearTimeout(refreshTimer)
            if (is_exists_installing && policy === 2) {
                refreshTimer = setTimeout(() => {
                    queryStoreBots()
                    clearTimeout(refreshTimer)
                }, 1000)
            } else {
                clearTimeout(refreshTimer)
            }
            setBotList(res.data)
        } catch (error) {
            if (error.message) {
                setToast({
                    isOpen: true,
                    message: error.message,
                })
            }
        }
    }
    const handleBotInstall = async (bot: BotModel) => {
        try {
            await installStoreBot(bot.id)
            queryStoreBots()
        } catch (error) {
            if (error.message) {
                setToast({
                    isOpen: true,
                    message: error.message,
                })
            }
        }
    }
    const stayList = [
        {
            logo_url: IdiomIcon,
            name: '成语接龙',
        },
        {
            logo_url: ConfrontationIcon,
            name: '对仗游戏',
        },
        {
            logo_url: LegalIcon,
            name: '法律知识库',
        },
        {
            logo_url: TourismIcon,
            name: '旅游景点查询',
        },
        {
            logo_url: AnswerIcon,
            name: '抢答游戏',
        },
        {
            logo_url: ConstellationIcon,
            name: '星座运势',
        },
        {
            logo_url: HrIcon,
            name: 'HR助手',
        },
    ]
    return (
        <IonPage className='bot-store-page'>
            <IonContent className='bot-store-content'>
                {!searchBarShow && (
                    <Header title='应用商店'>
                        <HeaderOptions
                            onSearch={() => {
                                setPolicy(1)
                                setSearchBarShow(true)
                            }}
                            onGoMyBot={() => history.replace(MyBotPage)}
                        />
                    </Header>
                )}
                <div className='bot-type-box'>
                    <button
                        className={cx('bot-type-btn', {
                            'bot-type-btn-active': !botType,
                        })}
                        onClick={() => setBotType(undefined)}
                    >
                        全部
                    </button>
                    <button
                        className={cx('bot-type-btn', {
                            'bot-type-btn-active': botType === 'KNOWLEDGE',
                        })}
                        onClick={() => setBotType('KNOWLEDGE')}
                    >
                        知识型
                    </button>
                    <button
                        className={cx('bot-type-btn', {
                            'bot-type-btn-active': botType === 'SKILL',
                        })}
                        onClick={() => setBotType('SKILL')}
                    >
                        技能型
                    </button>
                </div>
                {searchBarShow && (
                    <SearchBar
                        placeholder='请输入文字'
                        onChange={setSearchValue}
                        onCancel={() => {
                            setSearchValue('')
                            setSearchBarShow(false)
                            setPolicy(2)
                        }}
                    />
                )}
                {botList.map((item) => (
                    <BotItem
                        type='botStore'
                        key={item.id}
                        item={item}
                        onClick={() => {
                            history.push(BotDetailPage, {
                                bot: item,
                                isStore: true,
                            })
                        }}
                        onBotAdd={() => handleBotInstall(item)}
                    />
                ))}
                {botList.length && !searchBarShow ? (
                    <div>
                        <p className='stay_tip'>敬请期待以下机器人应用</p>
                        {stayList.map((item) => {
                            return (
                                <div className='bot-item'>
                                    <img
                                        className='bot-item-icon'
                                        src={item.logo_url}
                                        alt='icon'
                                    />
                                    <div className='bot-item-content center'>
                                        {item.name}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                ) : null}
                {botList.length === 0 && !searchBarShow && (
                    <EmptyMsg show={true}>
                        暂无机器人，点击右上角搜索一下吧!
                    </EmptyMsg>
                )}
                <Toast
                    {...toast}
                    color='success'
                    position='top'
                    onClose={() => setToast({ ...toast, isOpen: false })}
                />
            </IonContent>
        </IonPage>
    )
}

export default BotStore
